module.exports = __webpack_public_path__ + "img/wintergarten.eca1b3b6.webp";